<template>
  <nav class="navigate-super" :class="{
    'nav-success': headerModel.type === 'success',
    'nav-warning': headerModel.type === 'warning'
  }">
    <header class="top-header">
      <div class="header-inner">
        <img
          src="@/assets/images/logoBienestarAztk.png"
          alt="Bienestar Azteca Digital"
          class="header-logo"
          width="160"
          height="80"
        />
      </div>
    </header>
    <div class="content-title">
      <h1 class="title-header">
        {{ headerModel.text || '' }}
      </h1>
    </div>
  </nav>
</template>

<script setup>
import { ref, watchEffect, onMounted, computed } from 'vue';

const props = defineProps({
  headerModel: {},
});

let headerModel = ref('');

onMounted(() => {
  headerModel.value = props.headerModel;
});

watchEffect(() => {
  headerModel = computed(() => props.headerModel);
});
</script>

<style scoped>
/* ── Header en código ────────────────────────────────────────── */
.top-header {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: clamp(80px, 12vh, 140px);
  background: radial-gradient(at 50% 50%, #80C913 0%, #006A3D 140%);
  clip-path: ellipse(100% 100% at 50% 0%);
  z-index: 100;
}

.header-inner {
  height: 100%;
  padding: 0 clamp(5px, 2vw, 20px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-logo {
  height: clamp(60px, 8vh, 100px);
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  display: block;
}

/* ── Título ──────────────────────────────────────────────────── */
.title-header {
  font-size: 32px;
}

.navigate-super {
  width: 100%;
  flex-grow: 0;
  height: auto;
}

.navigate-super h2 {
  font-size: 40px;
  text-align: center;
}

.nav-success {
  color: #0c825e;
}

.nav-warning {
  background-image: radial-gradient(circle at -12% 59%, #ee2a2a,
    #eecf2a 18%), linear-gradient(101deg, #ee2a2a 12%, #eec32a 54%, #ee882a 95%);
  color: #fd7100;
}

.content-title {
  margin-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
}

/* ── Tablet ──────────────────────────────────────────────────── */
@media (max-width: 1024px) {
  .top-header {
    height: 100px;
    clip-path: ellipse(130% 100% at 50% 0%);
  }
  .header-logo {
    height: 70px;
    margin-top: 10px;
  }
  .content-title { margin-top: 25px; }
  .title-header { font-size: 30px; }
}

/* ── Móvil ───────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .top-header {
    height: 100px;
    clip-path: ellipse(150% 100% at 50% 0%);
  }
  .header-inner { padding: 0 10px; }
  .header-logo {
    height: 65px;
    margin-top: 18px;
  }
  .title-header { font-size: 24px; margin-top: 0px; }
}

@media (max-width: 600px) {
  .content-title { margin-top: 20px; }
}

@media (max-width: 400px) {
  .content-title { margin-top: 15px; }
}

@media only screen and (min-width: 200px) and (max-width: 530px) {
  .navigate-super h1 { font-size: 40px; }
}

@media only screen and (min-width: 300px) and (max-width: 740px)
  and (min-height: 540px) and (max-height: 915px) and (orientation: portrait) {
  .navigate-super h1 { font-size: 40px; }
}

@media only screen and (min-width: 568px) and (max-width: 568px) and (orientation: landscape) {
  .navigate-super h1 { font-size: 40px; }
}

@media only screen and (min-width: 567px) and (max-width: 1025px)
  and (min-height: 300px) and (max-height: 730px) and (orientation: landscape) {
  .navigate-super h1 { font-size: 40px; }
}

@media only screen and (min-width: 741px) and (max-width: 1400px)
  and (min-height: 400px) and (max-height: 740px) {
  .title-header { font-size: 40px; }
}

@media only screen and (max-width: 1024px) and (max-height: 980px) {
  .title-header { font-size: 40px; }
}

@media only screen and (min-width: 1024px) {
  .title-header { font-size: 36px; }
}
</style>